<template>
  <thead class="bg-white/5">
    <slot />
  </thead>
</template>

<script setup lang="ts">
</script>
